<template>
  <div
    v-show="dialogWebcall"
    ref="draggableContainer"
    id="moduleWebcall"
  >
    <v-flex
      v-if="dialogWebcall"
    >
    <!-- 
      :style="{ 'top': positions.dialogY + 'px', 'left': positions.dialogX + 'px' }"
    -->
      <v-card class="elevation-10 blue-grey darken-3">
        <v-card-title primary-title class="tf_titleWebcall" @mousedown="dragMouseDown">
          <div class="white--text  ma-2" style="width: 100%;">
            <h3 class="title">{{webcallDialogTitle}}</h3>
          </div>
<!--
          <div>
            <div class="tf_wave-container mx-2">
              <div class="wave-bar"></div>
              <div class="wave-bar"></div>
              <div class="wave-bar"></div>
              <div class="wave-bar"></div>
            </div>
          </div>
-->
        </v-card-title>
        <v-card-text>
          
          <div class="white--text" >
            <div
              id="tf_localWebcall"
              :class="{'posAbs': remoteStream, 'posRel': !remoteStream, 'visioCall': visioCall, 'audioCall': !visioCall}"
            >
              <div
                v-if="activeConnexionPeer"
                id="tf_wave-local"
                class="tf_wave-container"
                :class="{'active': jeParle, 'inactive': !jeParle}"
              >
                <div class="wave-bar"></div>
                <div class="wave-bar"></div>
                <div class="wave-bar"></div>
              </div>
            </div>

            <div id="tf_remoteWebcall">
              <div 
                v-if="activeConnexionPeer"
                id="tf_wave-remote"
                class="tf_wave-container"
                :class="{'active': ilParle, 'inactive': !ilParle}"
              >
                <div class="wave-bar"></div>
                <div class="wave-bar"></div>
                <div class="wave-bar"></div>
              </div>
            </div>

            <div id="messageWebcall">{{messageWebcall}}</div>
          </div>
        </v-card-text>

        <v-card-actions >
          <div  v-if="!connectedConversation && sessionWebcall.action != 'closeWebCall'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small color="red" @click="rejetWebcall()">
                  <v-icon dark>block</v-icon>
                </v-btn>
              </template>
              <span>Ne pas prendre cet appel</span>
            </v-tooltip>
          </div>

          <div v-if="!connectedConversation && sessionWebcall.action != 'closeWebCall'">
            <v-btn class="white--text" color="green" round dark @click="startWebcall()">
              <v-icon left dark>call</v-icon> {{ $t('prendre l\'appel') }}
            </v-btn>
          </div>
          <div v-if="!connectedConversation && sessionWebcall.action == 'closeWebCall'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small color="red" @click="stopWebcall()">
                  <v-icon dark>close</v-icon>
                </v-btn>
              </template>
              <span>{{$t('close')}}</span>
            </v-tooltip>
          </div>

          <div v-if="connectedConversation">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small color="red" @click="stopWebcall()">
                  <v-icon dark>call_end</v-icon>
                </v-btn>
              </template>
              <span>Raccrocher</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small :class="muteMicStatus ? 'red' : 'green'" @click="toggleMic(muteMicStatus)">
                  <v-icon dark v-if="muteMicStatus">mic_off</v-icon>
                  <v-icon dark v-else>mic</v-icon>
                </v-btn>
              </template>
              <span v-if="muteMicStatus">Activer le micro</span>
              <span v-else>Couper le micro</span>
            </v-tooltip>
          </div>

          <div v-if="connectedConversation && visioCall">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small :class="muteCamStatus ? 'red' : 'green'" @click="toggleCam(muteCamStatus)">
                  <v-icon dark v-if="muteCamStatus">videocam_off</v-icon>
                  <v-icon dark v-else>videocam</v-icon>
                </v-btn>
              </template>
              <span v-if="muteCamStatus">Activer la caméra</span>
              <span v-else>Couper la caméra</span>
            </v-tooltip>

            <v-tooltip top v-if="!isMobileIOS">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small :class="blurStatus ? 'green' : 'grey'" @click="toggleBlur(blurStatus)">
                  <v-icon dark v-if="blurStatus">blur_on</v-icon>
                  <v-icon dark v-else>blur_off</v-icon>
                </v-btn>
              </template>
              <span v-if="blurStatus">Annuler le floutage du fond</span>
              <span v-else>Flouter le fond</span>
            </v-tooltip>

            <v-tooltip top v-if="cameras.length > 1">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2" fab dark small :class="camChange ? 'green' : 'green'" @click="changeCamera(camChange)">
                  <v-icon dark v-if="camChange">camera_front</v-icon>
                  <v-icon dark v-else>camera_rear</v-icon>
                </v-btn>
              </template>
              <span v-if="camChange">Caméra avant</span>
              <span v-else>Caméra arrière</span>
            </v-tooltip>
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import apiRTC from '@apirtc/apirtc'
import { AWSS3_STATIC } from '../../constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js' // Socket
import _ from 'lodash'
export default {
  // props: [
  //   'datasVisiteur'
  // ],
  data () {
    return {
      positions: {
        dialogX: 100,
        dialogY: 100,
        movementX: 0,
        movementY: 0
      },
      jeParle: false,
      ilParle: false,
      visioCall: false, // true = affichage de la video
      messageWebcall: '',
      activeConnexionPeer: false,
      demandeEnvoyee: false,
      waveAnime: false,
      blurStatus: false,
      localStream: null,
      remoteStream: null,
      muteMicStatus: false,
      muteCamStatus: true, // camera desactivé par default
      streamWithEffect: null,
      facingModeSelect: 'user',
      camChange: 0,
      createStreamOptions: {},
      ua: null,
      cameras: [],
      dataWebcall: null,
      selectedVideoInputId: null,
      webcallDialogTitle: this.$t('incomCall'),
      subscribedStreams: {},
      registerInformation: {
        cloudUrl: 'https://cloud.apirtc.com'
      },
      audioWebcall: new Audio(AWSS3_STATIC + '/sounds/sonnerieTel.mp3'),
      webcallName: null,
      connectedConversation: null,
      dialogWebcall: false,
      apzEntrepriseApi: this.$store.state._User.apzKey
      // apzEntrepriseApi: '5cc8b4e676dd3c92bdb7650c9327a1d3'
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName', 'account', 'isMobileIOS']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['status', 'sessionWebcall', 'sessionsPrivees']),
    ...mapState('_User', ['isMobileIOS', 'isMobile'])
  },
  watch: {
    // ----------------------------------------------------------------------------
    // Regarde si appel entrant
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionWebcall.action': function (val, oldVal) {
      console.log('change sessionWebcall action val :', val)
      if (val === 'demandeWebCall') {
        this.dialogWebcall = true
        this.webcallDialogTitle = this.$t('incomCall')
        this.messageWebcall = this.$t('Voulez-vous prendre cet appel de l\'internaute ' + this.sessionWebcall.visiteurID + ' ?')
        this.switchToStatus('busy')
        this.audioWebcall.loop = true
        this.audioWebcall.play() // play son webcall entrant
      } else if (val === 'rejetAppel') {
        // this.dialogWebcall = false
      } else if (val === 'closeWebCall') {
        // console.log('le client à couper la connexion')
        this.webcallDialogTitle = 'Appel interrompu'
        this.messageWebcall = this.$t('L\'internaute a coupé l\'appel ?')
        let dataChange = {
          changeVal: {
            action: 'closeWebCall',
            sessionId: '',
            visiteurID: this.sessionWebcall.visiteurID
          }
        }
        this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
        this.audioWebcall.pause() // stop le son webcall entrant
      } else {
        // this.dialogWebcall = false
      }
    },
    // ----------------------------------------------------------------------------
    // Regarde si canal video activé
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionWebcall.camera': function (val, oldVal) {
      console.log('sessionWebcall caméra :', val)
      if (val) {
        this.visioCall = true // flux video activé
      } else {
        this.visioCall = false // flux video désactivé
      }
    }
  },

  created () {},

  mounted () {
    // si au chargement de la page et que l'internaute a coupé le webcall
    if (this.sessionWebcall.action === 'closeWebCall') {
      console.log('communication etait interrompu')
      // il faut faire un reset du webcall
      this.$store.commit('_StoreWatcheeBox/DEL_SESSION_WEBCALL')
    }
    if (window.localStorage.getItem('tf_VisioWindowPos')) {
      let storagePos = window.localStorage.getItem('tf_VisioWindowPos')
      // console.log('storagePos', JSON.parse(storagePos).x)
      storagePos = JSON.parse(storagePos)
      if (storagePos.x) {
        this.positions.dialogX = storagePos.x
        this.positions.dialogY = storagePos.y
      } else {
        this.positions.dialogX = 100
        this.positions.dialogY = 100
      }
      // console.log('mounted ref', this.$refs.draggableContainer)
      // console.log('mounted x', this.positions.dialogX)
      // console.log('mounted y', this.positions.dialogY)
      this.$refs.draggableContainer.style.top = this.positions.dialogY + 'px'
      this.$refs.draggableContainer.style.left = this.positions.dialogX + 'px'
    }
    // fond flouté activé
    if (window.localStorage.getItem('tf_VisioBlur')) {
      if (window.localStorage.getItem('tf_VisioBlur') === 'false') {
        this.blurStatus = false
      } else {
        this.blurStatus = true
      }
      // console.log('this.blurStatus', this.blurStatus)
    } else {
      this.blurStatus = false
    }
    // micro activé/inactivé
    if (window.localStorage.getItem('tf_muteMic')) {
      if (window.localStorage.getItem('tf_muteMic') === 'false') {
        this.muteMicStatus = false
      } else {
        this.muteMicStatus = true
      }
    } else {
      this.muteMicStatus = false // activé par defaut
    }
    // caméra activé/inactivé
    if (window.localStorage.getItem('tf_muteCam')) {
      if (window.localStorage.getItem('tf_muteCam') === 'false') {
        this.muteCamStatus = false
      } else {
        this.muteCamStatus = true
      }
    } else {
      this.muteCamStatus = true // desactivé par defaut
    }
    // console.log('datavisteur webcall : ', this.sessionWebcall)
    if (this.sessionWebcall.sessionId) {
      this.dialogWebcall = true
      // this.switchToStatus('busy')
    }
    // si l'agent est deja en visiconf, il faut le reconnecter
    if (this.sessionWebcall.sessionId) {
      // console.log('---> mounted --- this.sessionWebcall.sessionId', this.sessionWebcall.sessionId)
      this.startWebcall()
      let dataChange = {
        changeVal: {
          startConf: true,
          visiteurID: this.sessionWebcall.visiteurID
        }
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
    } else {
      let dataChange = {
        changeVal: {
          startConf: false,
          visiteurID: this.sessionWebcall.visiteurID
        }
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
    }
    if (this.sessionWebcall.camera) {
      this.visioCall = true
    }
    this.apzEntrepriseApi = this.$store.state._User.apzKey
  },

  beforeDestroy () {
    /* eslint-disable */
    // console.log('beforeDestroy connectedConversation')
    if(typeof this.connectedConversation !== 'undefined') this.stopWebcall (this.sessionWebcall.visiteurID)
    /* eslint-enable */
    // this.$store.commit('_StoreWatcheeBox/LEAVE_SESSION_VISIOVENTE')
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', ['SET_STATUS', 'SET_STATUS_MANUALLY']),
    dragMouseDown (event) {
      // console.log('dragMouseDown', event)
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.dialogX = event.clientX
      this.positions.dialogY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag (event) {
      // console.log('elementDrag', event)
      // console.log('pos xy', document.getElementById('moduleWebcall').offsetLeft)
      event.preventDefault()
      this.positions.movementX = this.positions.dialogX - event.clientX
      this.positions.movementY = this.positions.dialogY - event.clientY
      this.positions.dialogX = event.clientX
      this.positions.dialogY = event.clientY
      // set the element's new position:
      this.$refs.draggableContainer.style.top = (this.$refs.draggableContainer.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggableContainer.style.left = (this.$refs.draggableContainer.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement (event) {
      // console.log('closeDragElement', event.clientX)
      window.localStorage.setItem('tf_VisioWindowPos', JSON.stringify({'x': document.getElementById('moduleWebcall').offsetLeft, 'y': document.getElementById('moduleWebcall').offsetTop}))
      document.onmouseup = null
      document.onmousemove = null
    },
    // -------------------------------------------
    // demarrer le webcall
    // -------------------------------------------
    startWebcall () {
      // console.log('start webcall ', this.sessionWebcall)
      this.dataWebcall = _.cloneDeep(this.sessionWebcall)
      this.activeConnexionPeer = true
      // Get conference name
      this.webcallName = 'conf_' + this.sessionWebcall.visiteurID
      // ==============================
      // 1/ CREATE USER AGENT
      // ==============================
      apiRTC.setLogLevel(0) // affichage des log apirtc

      this.ua = null
      // if (this.ua) {
      //   this.ua = null
      // }
      // console.log('apzkey', this.apzEntrepriseApi)
      // console.log(this.apzEntrepriseApi)
      this.ua = new apiRTC.UserAgent({
        uri: 'apzkey:' + this.apzEntrepriseApi
      })

      // ==============================
      // 2/ REGISTER
      // ==============================
      this.ua.register(this.registerInformation)
      .then((session) => {
        // Save session
        // this.connectedSession = session
        // this.registerApiRtc = true
        // enregistre dans le store les infos de la session
        this.dataWebcall.confName = this.webcallName
        this.dataWebcall.sessionId = session.id
        // active la detection du speaker
        this.ua.enableActiveSpeakerDetecting(true, { threshold: 60 })

        // console.log('data dataWebcall', this.dataWebcall)
        // Affiche la liste des utilisateur connectés à la room
        session.on('contactListUpdate', (updatedContacts) => {
          // console.log('userAgent session - contactListUpdate', updatedContacts)
          if (this.connectedConversation !== null) {
            // this.setNumContact(this.connectedConversation.getContactsNumber())
          }
        })
        // console.log('User registered with session: ', session)

        // ==============================
        // 3/ CREATE CONVERSATION
        // ==============================
        // console.log('connexion conf name ', this.webcallName)
        this.connectedConversation = session.getConversation(this.webcallName)

        // ==============================
        // CREATE LOCAL STREAM
        // ==============================
        this.createStreamOptions = {constraints: {
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          },
          video: this.visioCall ? {facingMode: this.facingModeSelect} : this.visioCall
        }}
        this.ua.createStream(this.createStreamOptions)
        .then((stream) => {
          // Save local stream
          // console.log('stream ua', this.ua)
          // console.log('stream', stream)
          // ==============================
          // JOIN CONVERSATION
          // ==============================
          this.connectedConversation.join()
          .then((response) => {
            // le blur est activé et caméra activé
            if (this.blurStatus) {
              stream.applyVideoProcessor('blur').then((streamWithEffect) => {
                this.localStream = streamWithEffect
                this.attachLocalStreamWebcall(streamWithEffect)
              }).catch((error) => {
                console.error('Catch on applyVideoProcessor message : ', error.message)
                console.error('Catch on applyVideoProcessor appliedVideoProcessorType : ', error.appliedVideoProcessorType)
                console.error('Catch on applyVideoProcessor stream : ', error.stream)
                if (error.appliedVideoProcessorType === 'blur') {
                  // Nothing to do
                } else {
                  // stream is changed
                  this.localStream = error.stream
                  this.attachLocalStreamWebcall(error.stream)
                }
              })
            } else {
              this.localStream = stream
              this.attachLocalStreamWebcall(stream)
            }
            // ==============================
            // PUBLISH OWN STREAM
            // ==============================
            // this.connectedConversation.publish(this.localStream)
            this.webcallDialogTitle = this.$t('Appel en cours...')
            this.messageWebcall = this.$t('Internaute ' + this.sessionWebcall.visiteurID)
            let dataChange = {
              changeVal: {
                confName: this.webcallName,
                sessionId: session.id,
                visiteurID: this.dataWebcall.visiteurID
              }
            }
            this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
            this.audioWebcall.pause() // stop le son webcall entrant
          }).catch((err) => {
            console.error('Conversation join error', err)
          })
        }).catch((err) => {
          console.error('create stream error', err)
          // il faut efface le userAgent qui vient d'être créé
          // this.loading = false
          this.ua.unregister()
        })

        // active la detection du speaker
        this.ua.enableActiveSpeakerDetecting(true, { threshold: 60 })

        this.ua.on('mediaDeviceChanged', (event) => {
          // Listen for mediaDeviceChanged event to update devices list
          console.log('mediaDeviceChanged :', event)
          var res = this.ua.getUserMediaDevices()
          this.updateDeviceList(res)
        })
        // ==========================================================
        // WHEN NEW STREAM IS AVAILABLE IN CONVERSATION
        // ==========================================================
        this.connectedConversation.on('availableStreamsUpdated', (streams) => {
          console.log('availableStreamsUpdated', streams)
          // var keys = Object.keys(streams)

          // for (var i = 0, len = keys.length; i < len; i++) {
          //   console.log('streams[keys[i]]', streams[keys[i]])
          //   if (typeof this.subscribedStreams[keys[i]] === 'undefined') {
          //     // ==============================
          //     // SUBSCRIBE TO STREAM
          //     // ==============================
          //     console.log('keys[i]', keys[i])
          //     this.subscribedStreams[keys[i]] = streams[keys[i]]
          //     this.connectedConversation.subscribeToStream(keys[i])
          //   }
          // }
        })

        // ==========================================================
        // WHEN NEW STREAM IS ADDED TO CONVERSATION
        // ==========================================================
        this.connectedConversation.on('streamAdded', (stream) => {
          // Attach stream
          // var mediaElement = document.getElementById('tf_local-media')
          // // Get media container
          // var container = document.getElementById('tf_localWebcall')
          // if (mediaElement === null) {
          //   // Create media element
          //   mediaElement = document.createElement('video')
          //   mediaElement.id = 'tf_local-media'
          //   mediaElement.autoplay = true
          //   mediaElement.muted = true
          //   // Add media element to media container
          //   container.appendChild(mediaElement)
          // }
          // // document.getElementById('error-device').style.display = "none";
          // // Attach stream
          // stream.attachToElement(mediaElement)
          // stream.attachToElement(mediaElement)
          console.log('streamAdded', stream)
          // console.log('num contact', this.connectedConversation.getContactsNumber())
          // console.log('stream type', stream.getType())
          // console.log('stream settings', stream.getSettings())
          this.waveAnime = true
          this.audioWebcall.pause() // stop le son webcall entrant
        })

        // =====================================================
        // WHEN STREAM WAS REMOVED FROM THE CONVERSATION
        // =====================================================
        this.connectedConversation.on('streamRemoved', (streamInfos) => {
          console.log('streamRemoved')
          console.log(streamInfos)
          this.connectedConversation.unsubscribeToStream(streamInfos.streamId)
          // this.waveAnime = false
          // this.removeRemoteStreamWebcall()
        })

        this.connectedConversation.on('contactJoined', (event) => {
          // console.log('contactJoined', event)
        })

        this.connectedConversation.on('contactLeft', (event) => {
          // console.log('contactLeft', event)
          this.webcallDialogTitle = this.$t('Fin de l\'appel')
          this.messageWebcall = ''
          let dataChange = {
            changeVal: {
              confName: false,
              sessionId: null,
              visiteurID: null,
              visiteurSocketID: null,
              siteId: null,
              leaveConf: false,
              startConf: false,
              remoteStream: false
            }
          }
          this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
        })

        this.connectedConversation.on('joined', (event) => {
          // console.log('joined', event)
        })

        this.connectedConversation.on('left', (event) => {
          // console.log('userAgent left', event)
          this.ua.unregister()
          .then(() => {
            // OK : UserAgent is disconnected from the ApiRTC platform
            this.ua = null
            this.activeConnexionPeer = false
            // console.log('UA effacé', this.ua)
          })
          .catch((error) => {
            // error : an error occured during unregistration
            console.log('erreur durant le processus de suppression du userAgent', error)
          })
        })

        this.connectedConversation.on('localStreamUpdated', (event) => {
          console.log('localStreamUpdated', event)
        })

        this.connectedConversation.on('streamListChanged', (streamInfo) => {
          // console.log('streamListChanged', streamInfo)
          if (streamInfo.listEventType === 'added') {
            // c'est bien le remoteStream
            if (streamInfo.isRemote) {
              this.connectedConversation.subscribeToMedia(streamInfo.streamId)
              .then((stream) => {
                console.log('subscribeToMedia success', stream)
                this.connectedConversation.subscribeToStream(streamInfo.streamId)
                this.attachRemoteStreamWebcall(stream)
              }).catch((err) => {
                console.error('subscribeToMedia error', err)
              })
            }
          }
        })

        // detecte si la personne parle
        this.connectedConversation.on('audioAmplitude', amplitudeInfo => {
          console.log('amplitudeInfo : ', amplitudeInfo)
          console.log('this.remoteStream', this.remoteStream)
          console.log('this.localStream', this.localStream)
          // le stream local
          if (this.localStream && this.localStream.userMediaStreamId === amplitudeInfo.streamId) {
            if (amplitudeInfo.isSpeaking) {
              console.log('je parle !!')
              this.jeParle = true
            } else {
              console.log('je parle plus !!')
              this.jeParle = false
            }
          }
          // le stream remote
          if (this.remoteStream && this.remoteStream.streamId === amplitudeInfo.streamId) {
            if (amplitudeInfo.isSpeaking) {
              console.log('il parle !!')
              this.ilParle = true
            } else {
              console.log('il parle plus !!')
              this.ilParle = false
            }
          }
        })
      }).catch((err) => {
        console.error('User registered error', err)
      })
    },

    // ==============================
    // update liste des device dispo
    // ==============================
    updateDeviceList (res) {
      // console.log('updateDeviceList', (res))
      // init la liste des caméras dispo
      this.cameras = []
      for (var i = 0; i < Object.values(res.videoinput).length; i++) {
        var v = Object.values(res.videoinput)[i]
        console.log('getCameras', v)
        this.cameras.push(v)
      }
      if (this.selectedVideoInputId !== null) {
        // selectCamera.value = this.selectedVideoInputId
      }
      console.log('cameras', this.cameras)
    },

    // ==============================
    // Change de caméra
    // changement entre la première et la seconde camera
    // a voir si plus de 2 cameras dispo
    // ==============================
    changeCamera (cam) {
      console.log('changeCamera', cam)
      // il faut bien arreter la publication du local stream actuel
      // avant de créer un nouveau local stream
      this.connectedConversation.unpublish(this.localStream)
      // il faut effacer le local stream actuel si il existe
      if (this.localStream !== null) {
        this.localStream.release()
      }
      // création desoptions pour le stream
      this.createStreamOptions = {}
      // pour les mobile uniquement
      if (this.isMobile) {
        // createStreamOptions.facingMode = 'environment';
        if (this.facingModeSelect === 'user') {
          this.facingModeSelect = 'environment'
        } else {
          this.facingModeSelect = 'user'
        }
        // createStreamOptions.facingMode = facingModeSelect
        this.createStreamOptions.constraints = {
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          },
          // audio: true,
          video: {
            facingMode: this.facingModeSelect
          }
        }
      } else {
        if (cam) {
          this.camChange = 0
        } else {
          this.camChange = 1
        }
        this.createStreamOptions.audioInputId = this.cameras[this.camChange].id
        this.createStreamOptions.videoInputId = this.cameras[this.camChange].id
        this.createStreamOptions.constraints = {
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          },
          // audio: true,
          video: this.visioCall
        }
      }

      console.log('createStreamOptions', this.createStreamOptions)
      this.ua.createStream(this.createStreamOptions)
        .then((stream) => {
          // le blur est activé
          if (this.blurStatus) {
            stream.applyVideoProcessor('blur').then((streamWithEffect) => {
              this.localStream = streamWithEffect
              this.attachLocalStreamWebcall(streamWithEffect)
            }).catch((error) => {
              console.error('Catch on applyVideoProcessor message : ', error.message)
              console.error('Catch on applyVideoProcessor appliedVideoProcessorType : ', error.appliedVideoProcessorType)
              console.error('Catch on applyVideoProcessor stream : ', error.stream)
              if (error.appliedVideoProcessorType === 'blur') {
                // Nothing to do
              } else {
                // stream is changed
                this.localStream = error.stream
                this.attachLocalStreamWebcall(error.stream)
              }
            })
          } else {
            this.localStream = stream
            this.attachLocalStreamWebcall(stream)
          }
        })
        .catch((err) => {
          console.error('create stream error', err)
          // reject()
        })
    },

    // -------------------------------------------
    // arrete le webcall
    // -------------------------------------------
    stopWebcall (sessionId) {
      console.log('stopWebcall', sessionId)
      // Leave Conversation
      if (this.connectedConversation !== null) {
        // Leaving actual conversation
        this.connectedConversation.leave()
        .then(() => {
          // console.debug('Conversation leave OK')
          this.connectedConversation.destroy()
          this.connectedConversation = null
          this.localStream.release()
        }).catch((err) => {
          console.error('Conversation leave error', err)
        })
      }
      // efface du store les infos webcall
      this.$store.commit('_StoreWatcheeBox/DEL_SESSION_WEBCALL')
      // ferme la dialogBox
      this.dialogWebcall = false
      this.waveAnime = false
      // this.switchToStatus('online')
    },

    // -------------------------------------------
    // arreter/marche le flou fond
    // -------------------------------------------
    toggleBlur (blurStatus) {
      // console.log('toggleBlur', this.localStream)
      // il faut bien arreter la publication du local stream actuel
      // avant de créer un nouveau local stream
      this.connectedConversation.unpublish(this.localStream)
      // il faut effacer le local stream actuel si il existe
      // if (this.localStream !== null) {
      //   this.localStream.release()
      // }
      if (blurStatus) {
        this.localStream.applyVideoProcessor('none').then((streamWithEffect) => {
          this.localStream = streamWithEffect
          this.attachLocalStreamWebcall(streamWithEffect)
          window.localStorage.setItem('tf_VisioBlur', false)
        }).catch((error) => {
          console.error('Catch on applyVideoProcessor message : ', error.message)
          console.error('Catch on applyVideoProcessor appliedVideoProcessorType : ', error.appliedVideoProcessorType)
          console.error('Catch on applyVideoProcessor stream : ', error.stream)
          if (error.appliedVideoProcessorType === 'none') {
            // Nothing to do
          } else {
            // stream is changed
            this.localStream = error.stream
            this.attachLocalStreamWebcall(error.stream)
          }
        })
        // this.localStream.unblur()
        this.blurStatus = false
      } else {
        this.localStream.applyVideoProcessor('blur').then((streamWithEffect) => {
          this.localStream = streamWithEffect
          this.attachLocalStreamWebcall(streamWithEffect)
          window.localStorage.setItem('tf_VisioBlur', true)
        }).catch((error) => {
          console.error('Catch on applyVideoProcessor message : ', error.message)
          console.error('Catch on applyVideoProcessor appliedVideoProcessorType : ', error.appliedVideoProcessorType)
          console.error('Catch on applyVideoProcessor stream : ', error.stream)

          if (error.appliedVideoProcessorType === 'blur') {
            // Nothing to do
          } else {
            // stream is changed
            this.localStream = error.stream
            this.attachLocalStreamWebcall(error.stream)
          }
        })
        // this.localStream.blur()
        this.blurStatus = true
      }
      console.log('toggleBlur :: this.localStream', this.localStream)
    },

    // -------------------------------------------
    // arreter/marche du micro
    // -------------------------------------------
    toggleMic (muteMicStatus) {
      console.log('toggleMic', muteMicStatus)
      if (muteMicStatus) {
        this.localStream.unmuteAudio()
        this.muteMicStatus = false
        window.localStorage.setItem('tf_muteMic', false)
      } else {
        this.localStream.muteAudio()
        this.muteMicStatus = true
        window.localStorage.setItem('tf_muteMic', true)
      }
    },
    // applique au démarrage de la vidéo  le status du micro
    applyStatusMic (muteMicStatus) {
      console.log('applyStatusMic', muteMicStatus)
      if (muteMicStatus) {
        this.localStream.muteAudio()
      } else {
        this.localStream.unmuteAudio()
      }
    },

    // -------------------------------------------
    // arreter/marche dela caméra
    // -------------------------------------------
    toggleCam (muteCamStatus) {
      console.log('toggleCam', muteCamStatus)
      if (muteCamStatus) {
        this.localStream.unmuteVideo()
        this.muteCamStatus = false
        window.localStorage.setItem('tf_muteCam', false)
      } else {
        this.localStream.muteVideo()
        this.muteCamStatus = true
        window.localStorage.setItem('tf_muteCam', true)
      }
    },
    // applique au démarrage de la vidéo  le status de la camera
    applyStatusCam (muteCamStatus) {
      console.log('applyStatusCam', muteCamStatus)
      if (muteCamStatus) {
        this.localStream.muteVideo()
      } else {
        this.localStream.unmuteVideo()
      }
    },

    // ----------------------------------------------------------------------------
    // change le status de l('agent en fonction du webcall)
    // ----------------------------------------------------------------------------
    switchToStatus (status) {
      // _watcheebox.changeStatusAgent({
      //   statut: status,
      //   agentID: this.user.id,
      //   sessionsPrivees: this.sessionsPrivees,
      //   roomName: this.user.entKey
      // })
      // // Sauve en Session le status choisi manuellement
      // this.SET_STATUS(status)
    },
    // ----------------------------------------------------------------------------
    // rejet un appel entrant
    // ----------------------------------------------------------------------------
    rejetWebcall () {
      let dataChange = {
        changeVal: {
          action: 'rejetAppel',
          sessionId: '',
          visiteurID: this.sessionWebcall.visiteurID
        }
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
      this.audioWebcall.pause() // stop le son webcall entrant
      // Connexion de l'agent
      _watcheebox.actionsWebcall({
        // 'socket': this.$socket,
        action: 'rejetAppel',
        sessionWebcall: this.sessionWebcall,
        agentSocketID: this.WATCHEEBOX_STATE.mySocketID,
        datasAgent: this.user,
        agentName: unescape(this.fullName)
      })
      this.dialogWebcall = false
      this.waveAnime = false
      this.activeConnexionPeer = false
      this.switchToStatus('online')
    },

    // --------------------------------------------------------
    // attache le local stream dans le bon element
    // --------------------------------------------------------
    attachLocalStreamWebcall (stream) {
      console.log('attachLocalStreamWebcall', stream)
      // retirer le localstream de la div
      stream.removeFromDiv('tf_localWebcall', 'tf_local-media')
      this.localStream = stream
      // affiche le nouveau stream dans la div
      this.localStream.addInDiv('tf_localWebcall', 'tf_local-media', {width: '94px'}, true)
      this.connectedConversation.publish(this.localStream).then(publishedStream => {
        // local stream is published
        console.log('start publishedStream', publishedStream)
        this.applyStatusCam(this.muteCamStatus) // mute la cam si mute activ
        this.applyStatusMic(this.muteMicStatus) // mute le micro si mue activ
      }).catch((error) => {
        console.log('start publishedStream error', error)// error
      })
      // }
      this.$emit('cacheInfosVisiteur')
      // console.log('attachLocalStreamWebcall :: this.localStream', this.localStream)
    },

    // --------------------------------------------------------
    // attache le remote stream dans le bon element
    // --------------------------------------------------------
    attachRemoteStreamWebcall (stream) {
      this.remoteStream = stream
      // this.remoteStream.unblur()
      // console.log('attache remote stream ', this.sessionWebcall)
      this.webcallDialogTitle = this.$t('Appel en cours...')
      this.messageWebcall = this.$t('Internaute ' + this.sessionWebcall.visiteurID)
      this.switchToStatus('busy')
      // Attache stream
      this.remoteStream.removeFromDiv('tf_remoteWebcall', 'tf_remote-media')
      this.remoteStream.addInDiv('tf_remoteWebcall', 'tf_remote-media', {width: '100%'}, false)
      let dataChange = {
        changeVal: {
          remoteStream: true,
          visiteurID: this.sessionWebcall.visiteurID
        }
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
    },
    // --------------------------------------------------------
    // remove la remote stream
    // --------------------------------------------------------
    removeRemoteStreamWebcall (stream) {
      console.log('remove remote stream')
      this.remoteStream = null
      this.webcallDialogTitle = this.$t('Appel interrompu')
      // remove stream
      // stream.removeFromDiv('tf_remoteWebcall', 'tf_remote-media')
      let dataChange = {
        changeVal: {
          remoteStream: false,
          visiteurID: this.sessionWebcall.visiteurID
        }
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_WEBCALL', dataChange)
    }
  }
}
</script>

<style>
#messageWebcall {
  z-index: 2;
  position: relative;
}
.tf_titleWebcall {
  cursor: all-scroll;
}
.tf_titleWebcall:hover {background-color: rgba(256, 256, 256, 0.1);}
#moduleWebcall {
    position: fixed;
    z-index: 50;
    width: 320px;
}
#tf_localWebcall.audioCall #tf_wave-local {top: -20px;}
#moduleWebcall .v-card {border-radius: 20px;}
.posAbs {position: absolute;}
.posRel {position: relative;}
#tf_localWebcall {display: block;}
/*--- locale stream ---*/
#tf_local-media {
  border-radius: 8px;
  border: 3px solid #37474f;
  margin-top: -3px;
  margin-left: -3px;
}
#tf_wave-local {
  z-index: 2;
  padding-left: 6px;
}
/*--- remote stream ---*/
#tf_wave-remote.inactive,
#tf_wave-local.inactive {display: none;}
#tf_wave-remote {
  right: calc(0px + 20px);
  padding-right: 4px;
}
#tf_wave-remote.tf_wave-container .wave-bar {
  height: 23px;
  margin-left: 0px;
}
/*--- wave stream audio ---*/
.tf_wave-container {
  position: absolute;
}
.tf_wave-container .wave-bar {
  display: inline-block;
  width: 3px;
  margin-left: 0px;
  height: 20px;
  background-color: rgba(256, 256, 256, 0.6);
  animation: beat1 1s infinite;
  transform: scaleY(0.1);
}
    
.tf_wave-container .wave-bar:nth-child(2n) {
  animation-name: beat2;
  animation-delay: 0.2s;
}
.tf_wave-container .wave-bar:nth-child(3n) {
  animation-name: beat3;
  animation-delay: 0.5s;
  animation-duration: 0.5s;
}
.tf_wave-container .wave-bar:nth-child(4n) {
  animation-name: beat2;
  animation-delay: 0.4s;
  animation-duration: 0.8s;
}
.tf_wave-container .wave-bar:nth-child(5n) {
  animation-delay: 0.6s;
}
.tf_wave-container .wave-bar:nth-child(6n) {
  animation-delay: 0.2s;
}

@keyframes beat1 {
  0% {
    transform: scaleY(0);
  }
  50% {
    transform: scaleY(0.7);
  }
  100% {
    transform: scaleY(0);
  }
}

@keyframes beat2 {
  0% {
    transform: scaleY(0);
  }
  50% {
    transform: scaleY(0.5);
  }
  100% {
    transform: scaleY(0);
  }
}

@keyframes beat3 {
  0% {
    transform: scaleY(0);
  }
  50% {
    transform: scaleY(0.3);
  }
  100% {
    transform: scaleY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzModuleWebcallAPZ.vue